import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import ShareIcon from '@mui/icons-material/Share';
import Button from '@mui/material/Button';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import ClosedCaptionOutlinedIcon from '@mui/icons-material/ClosedCaptionOutlined';
import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined';
import ReactStars from 'react-rating-stars-component';

import ShareLink from 'uI/ShareLink/ShareLink';

import { getShareLink } from 'store/product-actions';

import classes from './TopSection.module.css';

const TopSection = ({ courseData, users, courseReviews }) => {
  const userInfo = useSelector(state => state.userInfo);
  const { productType, idProduct, academyName } = useParams();
  const [openMessage, setOpenMessage] = useState(false);
  const [link, setLink] = useState('');

  const shareLinkHandler = () => {
    (async () => {
      setLink(await getShareLink(idProduct, 3));
      setOpenMessage(true);
    })();
  };

  const closeDialogHandler = () => {
    setOpenMessage(false);
  };

  return (
    <>
      <div className={classes.topContainer}>
        <aside className={classes.infoContainer}>
          <figure className={classes.imgCourse}>
            <img
              className={classes.img}
              src={courseData.path}
              alt={courseData.name}
            />
          </figure>
          <p className={classes.courseName}>{courseData.name}</p>
          <p className={classes.academyName}>
            Curso de {courseData.shortEmisor}
          </p>
          <div className={classes.complementaryInfoContainer}>
            <div className={classes.ratingContainer}>
              <p className={classes.item}>Opiniones de Usuarios</p>
              <aside className={classes.avgStars}>
                <ReactStars
                  edit={false}
                  count={5}
                  isHalf={true}
                  size={20}
                  activeColor="#e6a817"
                  emptyStarColor="#d6d6d6"
                  value={courseReviews}
                />
              </aside>
            </div>
            <div className={classes.moreInfoContainer}>
              <p className={classes.item}>
                <GroupOutlinedIcon className={classes.icon} />
                Alumnos inscritos {users}
              </p>
              <p className={classes.item}>
                <VolumeUpOutlinedIcon className={classes.icon} />
                Audio: Español
              </p>
              <p className={classes.item}>
                <ClosedCaptionOutlinedIcon
                  className={classes.icon}
                />
                Español
              </p>
            </div>
            {userInfo.data.username && (
              <Button
                onClick={shareLinkHandler}
                className={classes.shareBtn}
              >
                <ShareIcon className={classes.shareIcon} />
                Compartir
              </Button>
            )}
            {openMessage && (
              <ShareLink
                openDialog={openMessage}
                closeDialog={closeDialogHandler}
                link={link}
              />
            )}
          </div>
        </aside>
        <Button
          className={classes.btnPay}
          component="a"
          target="_blnak"
          href={`${process.env.REACT_APP_API_URL_PAGOS}/cart/checkout/${productType}/${courseData.idEmisor}/${academyName}/${idProduct}`}
        >
          <ShoppingCartOutlinedIcon className={classes.btnIcon} />{' '}
          Continuar con la compra
        </Button>
      </div>
      <div className={classes.topContainerFixed}>
        <aside className={classes.infoContainer}>
          <figure className={classes.imgCourse}>
            <img
              className={classes.img}
              src={courseData.path}
              alt={courseData.name}
            />
          </figure>
          <p className={classes.courseNameFix}>{courseData.name}</p>
          <p className={classes.academyNameFix}>
            Curso de {courseData.shortEmisor}
          </p>
          <div className={classes.complementaryInfoContainer}>
            <div className={classes.ratingContainer}>
              <p className={classes.item}>Opiniones de Usuarios</p>
              <aside className={classes.avgStars}>
                <ReactStars
                  edit={false}
                  count={5}
                  isHalf={true}
                  size={20}
                  activeColor="#e6a817"
                  emptyStarColor="#d6d6d6"
                  value={courseReviews}
                />
              </aside>
            </div>
            <div className={classes.moreInfoContainer}>
              <p className={classes.item}>
                <GroupOutlinedIcon className={classes.icon} />
                Alumnos inscritos {users}
              </p>
            </div>
          </div>
        </aside>

        <Button
          className={classes.btnPay}
          component="a"
          target="_blnak"
          href={`${process.env.REACT_APP_API_URL_PAGOS}/cart/checkout/${productType}/${courseData.idEmisor}/${academyName}/${idProduct}`}
        >
          <ShoppingCartOutlinedIcon className={classes.btnIcon} />{' '}
          Continuar con la compra
        </Button>
      </div>
    </>
  );
};

TopSection.propTypes = {
  // eslint-disable-next-line react/require-default-props
  courseData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  users: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  courseReviews: PropTypes.object
};

export default TopSection;
